import { ReactNode, useEffect } from 'react';
import { Navbar } from 'react-daisyui';
// TODO(MSR3-sidebar-cleanup): Remove Link import when fully migrated
import { Link, useLocation, useParams } from 'react-router-dom';
import { MSR3_HOME_FLAGS } from '../../constant/featureFlags';
// TODO(MSR3-sidebar-cleanup): Remove IfFeatureEnabledMSR3 import when fully migrated
import { userService } from '../../reducers/permissions/userSlice';
import { workspaceService } from '../../reducers/workspaces/workspaceSlice';
import { useAppDispatch, useTypedSelector } from '../../stateStore';
import { IfFeatureEnabledMSR3 } from '../IfFeatureEnabledMSR3';
import { MigrationSwitch } from '../MigrationSwitch';
import './AppSidebar.css';
import { WorkspaceSidebarIcons } from './WorkspaceSidebarIcons';

export interface IAppSidebarProps {
  children?: ReactNode;
  onClick?: () => void;
}

const Logo = (props: React.ComponentProps<'div'>) => (
  <div color="ghost" {...props}>
    <img
      alt="Screenrights"
      className="mx-auto h-12 w-[54.085px]"
      src="/logo_sr.svg"
    />
  </div>
);

const AppSidebar = ({ children, onClick }: IAppSidebarProps) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const currentUser = useTypedSelector(userService.selectors.userMe);
  const { workspaceId } = useParams();

  const isDashboard = location.pathname.includes('dashboard');
  const hasSubMenu = !!children;

  useEffect(() => {
    if (!currentUser) return;

    return () => {
      dispatch(workspaceService.actions.reset());
    };
  }, [currentUser, dispatch]);

  // Dashboard always uses the old sidebar layout
  if (isDashboard) {
    return (
      <Navbar
        id="mainNavbar"
        className={`h-screen bg-transparent p-0 text-sr-white lg:bg-sr-white ${
          hasSubMenu ? 'w-64' : 'w-[100px]'
        }`}
        onClick={() => onClick?.()}
      >
        <div className="inline-flex h-full w-full flex-shrink-0 flex-col items-start gap-7 bg-sr-black px-2 py-5">
          <Logo className="flex flex-col items-center justify-center gap-3 self-stretch" />
          {children ?? <WorkspaceSidebarIcons />}
        </div>
      </Navbar>
    );
  }

  // TODO(MSR3-sidebar-cleanup): Remove IfFeatureEnabledMSR3 wrappers, keep only first Navbar
  return (
    <>
      <IfFeatureEnabledMSR3 name="msr3.customerApp.sidebar" isEnabled="true">
        <Navbar
          id="mainNavbar"
          className="h-screen w-64 bg-transparent p-0"
          onClick={() => onClick?.()}
        >
          {children ?? <WorkspaceSidebarIcons />}
        </Navbar>
      </IfFeatureEnabledMSR3>
      <IfFeatureEnabledMSR3 name="msr3.customerApp.sidebar" isEnabled="false">
        <Navbar
          id="mainNavbar"
          className={`h-screen bg-transparent p-0 text-sr-white lg:bg-sr-white ${
            hasSubMenu ? 'w-64' : 'w-[100px]'
          }`}
          onClick={() => onClick?.()}
        >
          <div className="inline-flex h-full w-full flex-shrink-0 flex-col items-start gap-7 bg-sr-black px-2 py-5">
            <div className="flex flex-col items-center justify-center gap-3 self-stretch">
              <MigrationSwitch
                featureFlags={MSR3_HOME_FLAGS}
                newComponent={
                  <Link
                    to={workspaceId ? `/workspace/${workspaceId}/home` : '/'}
                  >
                    <Logo />
                  </Link>
                }
                oldComponent={
                  <Link to="/dashboard">
                    <Logo />
                  </Link>
                }
              />
            </div>
            {children ?? <WorkspaceSidebarIcons />}
          </div>
        </Navbar>
      </IfFeatureEnabledMSR3>
    </>
  );
};

export default AppSidebar;
